import { Button, Card } from '@/components/ui'

/**
 * Два разных ответа на два разных вопроса — «прав нет» и «не смогли проверить».
 *
 * До 21.08.2026 они были одним: `usePedagogyAccess` сводил любую ошибку к
 * `null`, и обрыв сети выглядел как отзыв прав — человека выбрасывало из
 * раздела без единого слова (AUDIT_PEDAGOGY_UX_2026-08-21.md, P0). Разница не
 * косметическая: в первом случае идти к администратору правильно, во втором —
 * бессмысленно, надо нажать «Повторить».
 */

/** Проверить доступ не удалось: сеть, протухший JWT, таймаут. Не редиректим. */
export function PedagogyAccessErrorCard({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="space-y-4 pb-24">
      <Card>
        <div className="space-y-3 py-6 text-center">
          <div className="text-sm font-medium text-foreground">Не удалось проверить доступ</div>
          <div className="text-sm text-muted-foreground">
            Похоже на проблему со связью. Права не изменились — проверка просто не дошла до сервера.
          </div>
          <Button type="button" size="sm" variant="secondary" onClick={onRetry}>
            Повторить
          </Button>
        </div>
      </Card>
    </div>
  )
}

/** Прав действительно нет. Здесь помогает только администратор. */
export function PedagogyAccessDeniedCard({ message }: { message?: string }) {
  return (
    <div className="space-y-4 pb-24">
      <Card>
        <div className="py-6 text-center text-sm text-muted-foreground">
          {message
            ?? 'Раздел педагогов доступен специалистам по педагогам, руководителю педагогов и сотрудникам УК уровня advanced.'}
        </div>
      </Card>
    </div>
  )
}
